import React, { useState } from 'react';
import { Card, CardContent, Chip, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Stack, Tooltip } from '@mui/material';
import { Edit, Delete, ContentCopy, Notifications, NotificationsOff } from '@mui/icons-material';
import AlarmSummary from "./AlarmSummary";

const AlarmCard = ({ alarm, onEdit, onDelete, onClone, onToggleNotifications, disabled, trafficLights = [] }) => {
    const [openDialog, setOpenDialog] = useState(false);

    const renderAlarmStatusIcon = () => {
        switch (alarm.status) {
            case 'active':
                return '🟢 Active';
            case 'inactive':
                return '🔴 Inactive';
            default:
                return '';
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDelete = () => {
        onDelete();
        setOpenDialog(false);
    };

    const notificationsEnabled = alarm?.notifications_enabled !== false;

    return (
        <Card variant="outlined" sx={{ mb: 1, borderRadius: 5 }}>
            <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                marginTop:"-5px!important",paddingTop:"0!important", paddingBottom:"12px!important"
            }} >
                <div>
                    <AlarmSummary alarm={alarm} trafficLights={trafficLights} key={'summar' + alarm.rule} />
                </div>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Chip label={renderAlarmStatusIcon()} />
                    {!disabled && (
                        <>
                            <Tooltip title={notificationsEnabled ? 'Mute bell + sound' : 'Enable bell + sound'}>
                                <IconButton onClick={onToggleNotifications} size="small">
                                    {notificationsEnabled ? <Notifications fontSize="small" /> : <NotificationsOff fontSize="small" />}
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Clone alarm">
                                <IconButton onClick={onClone} size="small">
                                    <ContentCopy fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit alarm">
                                <IconButton onClick={onEdit} size="small">
                                    <Edit fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete alarm">
                                <IconButton onClick={handleOpenDialog} size="small">
                                    <Delete fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </Stack>
            </CardContent>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this alarm?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};

export default AlarmCard;
